import { Box } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import ContentAdmin from "components/contentAdmin";
import CustomButton from "components/customButton";
import useUser from "hooks/useUser";

import IMGHeaderImage from "./assets/images/header-image.png";
import IMGSectionBackground1 from "./assets/images/section-background1.jpg";

import SectionFour from "./components/FirstCompleteComponents/SectionFour";
import SectionOne from "./components/FirstCompleteComponents/SectionOne";
import SectionThree from "./components/FirstCompleteComponents/SectionThree";
import SectionTwo from "./components/FirstCompleteComponents/SectionTwo";

function MissionOneFirstComplete()
{
	const [ isMoneyBackExpanded, setIsMoneyBackExpanded ] = useState(false);
	const [ expandedAccordion, setExpandedAccordion ] = useState<0 | 1 | 2>(0);
	const [ isLoading, setIsLoading ] = useState(false);

	const { state: userState } = useUser();
	const navigate = useNavigate();

	function buyMissions()
	{
		navigate("/packages");
		// if (isLoading) return;
		// setIsLoading(true);

		// Api.transactions
		// 	.byAllMissions({ type: "full", id: undefined })
		// 	.then((data) =>
		// 	{
		// 		window.location.href = data;
		// 	})
		// 	.catch((error) => console.error(error))
		// 	.finally(() => setIsLoading(false));
	}

	function goToDashboard()
	{
		navigate("/dashboard");
	}

	return (
		<Box
			sx={{
				minHeight: "100vh",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",

				"@supports (min-height: 100dvh)": {
					minHeight: "100dvh"
				},

				"& .wrapper": {
					maxWidth: "1920px",
					margin: "0 auto"
				},
				"& section": {
					width: "100%",
					paddingTop: { xl: "80px", lg: "56px", xs: "40px" },
					paddingLeft: "32px",
					paddingRight: "32px"
				},
				"& h1, & h2": {
					width: "fit-content",
					maxWidth: { xl: "900px", lg: "636px" },
					margin: "0 auto",
					font: {
						xl: "700 64px/82px Lora-Bold",
						lg: "700 45px/58px Lora-Bold",
						xs: "700 24px/31px Lora-Bold"
					},
					color: "#FFFF",
					textAlign: "center"
				}
			}}
		>
			<Box
				// component="header"
				sx={{
					...(userState?.user?.fullSubscribe && {
						minHeight: "100vh"
					}),
					width: "100%",
					background: `url(${ IMGSectionBackground1 }) center center/cover`
				}}
			>
				<Box
					className="wrapper"
					sx={{
						padding: {
							xl: "213px 152px 131px 152px",
							lg: "150px 82px 92px 58px",
							xs: "32px 32px 44px 32px"
						},
						display: "grid",
						gridTemplateColumns: { lg: "1fr 1fr" },
						gridTemplateAreas: {
							lg: "'title image' 'content image'",
							xs: "'title' 'image' 'content'"
						},
						gap: { xl: "72px 28px", lg: "52px 0px" },
						justifyItems: "center",
						font: { lg: "400 22px 'Open Sans'", xs: "400 16px 'Open Sans'" },
						color: "#FFFFFF"
					}}
				>
					<Box
						component="h1"
						sx={{
							gridArea: "title",
							textAlign: "left",
							margin: "unset !important",
							justifySelf: { lg: "flex-start" }
						}}
					>
						<ContentAdmin
							keyText="mission-one-firstComplete"
							keyContent="header-title"
							defaultValue="{NAME}, you are amazing!"
							position="left"
						/>
					</Box>

					<Box
						sx={{
							gridArea: "image",
							position: "relative",
							"& img": {
								position: { lg: "absolute" },
								bottom: "50px",
								left: "50%",
								transform: { lg: "translateX(-50%)" },
								maxWidth: { xs: "286px", lg: "unset" },
								width: { xl: "728px", lg: "517px", xs: "100%" },
								height: { xl: "715px", lg: "507px", xs: "auto" }
							}
						}}
					>
						<img src={IMGHeaderImage} alt="" />
					</Box>

					<Box
						sx={{
							gridArea: "content",
							paddingRight: { lg: "66px" },
							marginTop: { xs: "24px", lg: "unset" }
						}}
					>
						<ContentAdmin
							keyText="mission-one-firstComplete"
							keyContent="header-information"
							defaultValue={`You’ve just taken a step to change your life for the better and completed your first mission.\n
								{NAME}, we know how you feel...stuck, lost, overwhelmed by all the options and not sure what to do next, it’s really hard.\n
								You could stay stuck like that or...you could create a life that exceeds your wildest dreams.`}
							position="left"
						/>
						<Box
							sx={{
								width: { lg: "fit-content" },
								margin: { xs: "0 auto", lg: "unset" },
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								gap: "24px"
							}}
						>
							<CustomButton.Base
								loading={isLoading}
								onClick={
									userState?.user?.fullSubscribe ? goToDashboard : buyMissions
								}
								sx={{
									width: { xs: "100%", sm: "auto" },
									marginTop: "72px",
									boxShadow: "unset"
								}}
							>
								{userState?.user?.fullSubscribe ? "Continue" : "Buy Full Quest"}
							</CustomButton.Base>

							<Box
								sx={{
									font: {
										xl: "700 24px 'Open Sans'",
										lg: "700 17px 'Open Sans'",
										xs: "700 14px 'Open Sans'"
									}
								}}
							>
								{userState?.user?.fullSubscribe === false && (
									<ContentAdmin
										keyText="mission-one-firstComplete"
										keyContent="header-moneyBack"
										defaultValue="Money back guarantee"
										position="left"
									/>
								)}
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>

			{/* Если полной подписки нет - выводим секции */}
			{userState?.user?.fullSubscribe === false && (
				<Box
					sx={{
						width: "100%"
					}}
				>
					<SectionOne />

					<SectionTwo
						isLoading={isLoading}
						isMoneyBackExpanded={isMoneyBackExpanded}
						setIsMoneyBackExpanded={setIsMoneyBackExpanded}
						buyMissions={buyMissions}
					/>

					<SectionThree
						expandedAccordion={expandedAccordion}
						setExpandedAccordion={setExpandedAccordion}
					/>

					<SectionFour />
				</Box>
			)}
		</Box>
	);
}

export default MissionOneFirstComplete;
